import {  useLocation } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
// import Sidebar from '../../components/Sidebar'
function ChavReport() {
  const location = useLocation();
  const { selectedDate } = location.state || {};
  const language = localStorage.getItem("language");
  const udiseNumber = localStorage.getItem("udiseNumber");
  const [schoolData, setSchoolData] = useState(null); 
  const [showModal, setShowModal] = useState(true);
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth()); // Default to current month
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear()); // Default to current year
  
  
      const DB_NAME = 'SchoolManagementDB';
    const SCHOOL_STORE = 'schoolData';
    const DB_VERSION = 1;



const openDB = () => {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);

    request.onerror = (event) => {
      console.error("IndexedDB error:", event.target.error);
      reject(event.target.error);
    };

    request.onsuccess = (event) => {
      const db = event.target.result;
      if (!db) {
        console.error("Error: db object is not initialized");
        reject("Error: db object is not initialized");
      } else {
        resolve(db);
      }
    };

    request.onupgradeneeded = (event) => {
      const db = event.target.result;

    
      if (!db.objectStoreNames.contains(SCHOOL_STORE)) {
        db.createObjectStore(SCHOOL_STORE, { keyPath: "udiseNumber" });
      }
    };
  });
};

  
     const fetchSchoolData = async () => {
  try {
    const db = await openDB();
    const transaction = db.transaction(SCHOOL_STORE, "readonly");
    const store = transaction.objectStore(SCHOOL_STORE);
    const udise = localStorage.getItem("udiseNumber");
    const request = store.get(udise);

    return new Promise((resolve) => {
      request.onsuccess = (event) => {
        const data = event.target.result;
        if (data) {
          console.log("School data from IndexedDB:", data);
          setSchoolData(data);
          resolve(data);
        } else {
          console.log("No school data found in IndexedDB, fetching from Firebase");
        }
      };

      request.onerror = (event) => {
        console.error("Error fetching school data from IndexedDB:", event.target.error);
      };
    });
  } catch (error) {
    console.error("Error accessing IndexedDB:", error);
  }
};
  useEffect(() => {
    fetchSchoolData(); 
  }, [selectedDate]); 

  const months = [
    { value: 0, label: language === "English" ? "January" : "जानेवारी" },
    { value: 1, label: language === "English" ? "February" : "फेब्रुवारी" },
    { value: 2, label: language === "English" ? "March" : "मार्च" },
    { value: 3, label: language === "English" ? "April" : "एप्रिल" },
    { value: 4, label: language === "English" ? "May" : "मे" },
    { value: 5, label: language === "English" ? "June" : "जून" },
    { value: 6, label: language === "English" ? "July" : "जुलै" },
    { value: 7, label: language === "English" ? "August" : "ऑगस्ट" },
    { value: 8, label: language === "English" ? "September" : "सप्टेंबर" },
    { value: 9, label: language === "English" ? "October" : "ऑक्टोबर" },
    { value: 10, label: language === "English" ? "November" : "नोव्हेंबर" },
    { value: 11, label: language === "English" ? "December" : "डिसेंबर" },
  ];

  
  const handlePrint = () => {
    const printContent = document.querySelector('.modal-content');
  
    if (printContent) {
      const cloneContent = printContent.cloneNode(true);
  
      const schoolName = cloneContent.querySelector('p');
      const otherDetails = cloneContent.querySelectorAll('p');
  
      otherDetails.forEach((p, index) => {
        if (index !== 0) { // Exclude the school name
          p.style.fontWeight = 'normal'; 
        }
      });
  
      if (schoolName) {
        schoolName.innerHTML = `<h5 style="font-size: 16px; margin-top: 10px;">${schoolData.schoolName}</h5>`;
      }
  
      // Add month and year to the print content
      const monthYearSection = cloneContent.querySelector('.Monthname');
      if (monthYearSection) {
        monthYearSection.innerHTML = `
          ${language === "English" ? "Month: " : "महिना: "} 
          ${months[selectedMonth].label} 
          ${selectedYear}
        `;
      }
  
      const printWindow = window.open('', '', 'height=600,width=800');
      printWindow.document.write(`
        <html>
          <head>
            <title>Print Modal Content</title>
            <style>
              @page {
                size: A4 portrait;
                margin: 5mm;
              }
              body {
                font-family: Arial, sans-serif;
                margin: 0;
              }
              .modal-content {
                margin: 20px;
              }
              thead {
                background-color: #F0F0F0;
              }
              .tip-style {
                text-align: center;
                font-size: 12px;
                margin-top: 20px;
              }
              #month-select {
                margin-right: -30px;
              }
              .Monthname {
                margin-left: 20px;
              }
                .Dailyrgposhan{
                margin-top:0;
                }
            </style>
          </head>
          <body>
            ${cloneContent.outerHTML}
          </body>
        </html>
      `);
      printWindow.document.close();
      printWindow.focus();
      printWindow.print();
      printWindow.close();
    } else {
      console.error('Print content not found');
    }
  };
  

  return (
    <div> 
    {/* <Sidebar/> */}
      <div className='main-content-of-page'>
        {showModal && (
          <div style={{
            position: 'fixed',
            top: '0',
            right: '0',
            width: '88%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: '1000',marginTop:'25px'
          }}>
            <div style={{
              backgroundColor: '#fff',
              padding: '30px',
              borderRadius: '10px',
              width: '850px',
              boxShadow: '0 4px 15px rgba(0, 0, 0, 0.9)',
              maxHeight: '90%',
              overflowY: 'auto',
              position: 'relative',
            }}>
              <div className="modal-content">
                <table style={{
                  width: '100%',
                  borderCollapse: 'collapse',
                  marginBottom: '30px',
                  fontFamily: 'Arial, sans-serif',
                  border: '1px solid black',
                  borderRadius: '10px',
                  boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
                }}>
                  <thead>
                    {schoolData && (
                      <tr>
                        <th colSpan="7" style={{
                          color: 'black',
                          padding: '5px',
                          borderRadius: '10px 10px 0 0',
                          textAlign: 'center',
                          lineHeight: '0.4',
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          fontSize: '13px',
                          position: 'relative' 
                        }}>
                          <p><strong><h6> {schoolData.schoolName}</h6></strong></p>
                          <p>{schoolData.sansthaName}</p>
                          <p>{language === "English" ? "Taluka:" : "तालुका:"} {schoolData.taluka} , {language === "English" ? "Jilha:" : "जिल्हा:"} {schoolData.jilha} </p>
                          <p style={{fontSize:'18px'}}>{language === "English" ? "School Nutrition Scheme" : "शालेय पोषण आहार योजना"}  </p>
                          <p className='Dailyrgposhan' style={{ display: 'inline-block', backgroundColor: '#252729', color: 'white', padding: '10px', borderRadius: '5px', fontSize: '14px' }}>
                            {language === "English" ? "Register about providing cooked food at the school level" : "शिजवुन अन्न देण्याबाबत शाळास्तरावर ठेवण्याची चव नोंदवही"}
                          </p>
                          <p className='Monthname' style={{ position: 'absolute', right: '10px', bottom: '2px', display: 'flex', alignItems: 'center' }}>
  {language === "English" ? "Month: " : "महिना: "}
  
  <select
  id="month-select"
  value={selectedMonth}
  onChange={(e) => setSelectedMonth(Number(e.target.value))}
  style={{
    marginLeft: '10px', paddingTop: '0', marginRight:'-0.9%',
    height: '30px', border: 'none', appearance: 'none',
    background: 'none', padding: '0', outline: 'none',
    cursor: 'pointer', fontSize: '13px', lineHeight: 'normal', width: '80px'
  }}
>
  {months.map((month) => (
    <option key={month.value} value={month.value}>
      {month.label}
    </option>
  ))}
</select>

<select
  id="year-select"
  value={selectedYear}
  onChange={(e) => setSelectedYear(e.target.value)}
  style={{
    paddingTop: '0', height: '30px', border: 'none', appearance: 'none',
    background: 'none', padding: '0', outline: 'none', cursor: 'pointer',
    fontSize: '13px', lineHeight: 'normal'
  }}
>
  <option>2023</option>
  <option>2024</option>
  <option>2026</option>
  <option>2027</option>
  <option>2028</option>
  <option>2029</option>
  <option>2030</option>
  <option>2031</option>
  <option>2032</option>
  <option>2033</option>
</select>


</p>


                        </th>
                      </tr>
                    )}
                    <tr style={{ color: 'black' }}>
                      <th style={{ borderLeft: '1px solid black', width: '100px', ...thstyle, padding: 'auto 0px' }}>{language === "English" ? "Date" : "दिनांक"}</th>
                      <th style={thstyle}>{language === "English" ? "Time of Tasting" : "चव घेतल्याची वेळ"}</th>
                      <th style={thstyle}>{language === "English" ? "Food Distribution Time" : "आहार वाटप वेळ"}</th>
                      <th style={thstyle}>{language === "English" ? "Today's Menu" : "आजचा मेनू"}</th>
                      <th style={thstyle}>{language === "English" ? "Name of the Taster" : "चव घेणाऱ्याचे नाव"}</th>
                      <th style={thstyle}>{language === "English" ? "Comment on Taste" : "चवीबद्दल अभिप्राय"}</th>
                      <th style={thstyle}>{language === "English" ? "Signature of the Taster" : "चव घेणाऱ्याची सही"}</th>
                    </tr>
                  </thead>

                  <tbody>
                    {/* Create 31 empty rows */}
                    {Array.from({ length: 31 }, (_, index) => (
                      <tr key={index}>
                        <td style={{ ...thstylebody, borderLeft: '1px solid black', padding: '15px 0' }}>{index + 1}</td>
                        <td style={thstylebody}></td>
                        <td style={thstylebody}></td>
                        <td style={thstylebody}></td>
                        <td style={thstylebody}></td>
                        <td style={thstylebody}></td>
                        <td style={thstylebody}></td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                <div className='text-center mt-3 Certificate-dailyposhan'>
                  <div className='signature-section' style={{ display: 'flex', justifyContent: 'space-between', margin: '0 auto', padding: '0 20px', fontSize: '13px', width: '70%', alignItems: 'center', marginTop: '10px' }}>
                  
                    <div className='principal-signature' style={{ textAlign: 'left' }}>
                      <p className='president-signature' style={{ textAlign: 'center', marginBottom: '0' }}>
                        {language === "English" ? "Principal" : "मुख्याध्यापक"}
                      </p>
                      <p className='schmgnt'>{language === "English" ? "Signature and Stamp" : "सही व शिक्का"}</p>
                    </div>


                    <div className='principal-signature' style={{ textAlign: 'right' }}>
                      <p className='president-signature' style={{ textAlign: 'center', marginBottom: '0' }}>
                        {language === "English" ? "President" : "अध्यक्ष"}
                      </p>
                      <p className='schmgnt'>{language === "English" ? "Village/Ward/School Management Committee" : "ग्राम/वॉर्ड/शाळा व्यवस्थापन समिती"}</p>
                    </div>
                  </div>
                  <div>
                  <p className='tip-style' style={{ fontSize: '12px', bottom:'0' }}>{language === "English" ? "Note: Grievance Redressal Center Toll Free Number 18002339988" : "टीप: तक्रार निवारण केंद्र टोल फ्री क्रमांक १८००२३३९९८८"}</p>
                  </div>
                </div>
              </div>

              <div style={{ textAlign: 'right', marginTop: '20px' }}>
              
              <button onClick={handlePrint} style={{
                  padding: '12px 20px',
                  backgroundColor: '#007BFF',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '5px',
                  cursor: 'pointer',
                  fontSize: '16px',
                  boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
                  transition: 'background-color 0.2s ease',
                  marginRight: '10px'
                }}>
                 Print
                </button>

              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default ChavReport;

const thstyle = {
  fontSize: '14px',
  padding: '0px',
  fontWeight: '600',
  borderBottom: '1px solid black',
  textAlign: 'center',
  borderRight: '1px solid black',
  width: '60px', color:'black'
}

const thstylebody = {
  fontSize: '12px',
  padding: '7px',
  borderBottom: '1px solid black',
  textAlign: 'center',
  color: 'black',
  borderRight: '1px solid black',
}